RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';
    const periodType = RivalIQ.enums.timePeriod.periodType;

    // NOTE it is not safe to call `save` from this model, as it will
    // send all attributes in the model which can cause 413s
    // see #11310, #11359, #11381
    models.Landscape = Backbone.Model.extend({
        urlRoot: '/api/landscape',
        type: 'Landscape', // Used for identifying this resource to the permissions system

        getCompany: function (id) {
            const me = this;
            const companies = me.get('companies');
            return companies.get(parseInt(id));
        },

        recordTimezone: function () {
            const me = this;

            if (RivalIQ.state.user.can('update', me)) {
                // NOTE per the note above on persistence we cannot call `save`
                // here, as the current usage is only with the landscape state
                // model, which contains a load of attributes we don't want to
                // persist

                // NOTE to handle existing scheduled reports w/o a set timezone we
                // look to the timeZone saved into viewstate first
                me.set({
                    timezone: RivalIQ.state.view.get('timeZone') || RivalIQ.utils.timezone.getClientTimezoneString()
                });
            }
        },

        validate: function (attrs) {
            const me = this;

            const errors = [];

            if (me.get('timezone') && !attrs.timezone) {
                errors.push(['timezone', 'Timezone is required']);
            }

            if (errors.length) {
                return errors;
            }
        },


        getMinimumDate: function (period) {
            const me = this;
            const historyLimits = RivalIQ.state.account.get('historyLimits');
            let periodLimit;

            switch (period) {
                case periodType.MAIN_PERIOD:
                    periodLimit = historyLimits.mainPeriod;
                    break;
                case periodType.COMPARE_PERIOD:
                    periodLimit = historyLimits.comparePeriod;
                    break;
                default:
                    throw new Error(`unknown time period ${period}`);
            }

            // we need to reduce this by one since the server "rounds up"
            const duration = periodLimit - 1;

            // these limits are base on the start of the main period
            return me.getMaximumDate(periodType.MAIN_PERIOD).subtract(duration, 'days').startOf('day');
        },

        getMaximumDate: function (period) {
            const me = this;

            const timezone = me.get('timezone') || 'UTC';

            switch (period) {
                case periodType.MAIN_PERIOD:
                    return RivalIQ.utils.timezone.getDateInTimezone(timezone, moment.utc()).endOf('day');
                case periodType.COMPARE_PERIOD:
                    return RivalIQ.utils.timezone.getDateInTimezone(timezone, moment.utc()).endOf('day').subtract(1, 'day');
                default:
                    throw new Error(`unknown time period ${period}`);
            }
        }
    });

}, window.moment);
